/**
 * Utility functions and error handling
 */

export function showError(message, debugMode) {
    if (debugMode === '1') {
        console.error(message);
    }
}

export function showKeyboardShortcuts(debugMode) {
    if (debugMode === '1') {
        console.log('Keyboard shortcuts:', {
            'Ctrl+K': 'Focus search',
            'Ctrl+/': 'Show shortcuts',
            'Escape': 'Clear search/close modals'
        });
    }
}

export function closeAllModals() {
    document.querySelectorAll('.modal.open').forEach(modal => {
        modal.classList.remove('open');
    });
}

export function trackEvent(eventName, data, debugMode) {
    if (debugMode === '1') {
        console.log('Track event:', eventName, data);
    }
}

export function broadcastThemeChange(modules, theme) {
    Object.values(modules).forEach(module => {
        if (typeof module.onThemeChange === 'function') {
            module.onThemeChange(theme);
        }
    });
}

export function handleInitError(error, debugMode) {
    document.body.classList.add('init-error');
    showError('Произошла ошибка при инициализации приложения', debugMode);

    if (debugMode === '1') {
        console.error('Initialization error details:', error);
    }

    // Ensure loader is not stuck on screen on errors
    try {
        const loader = document.getElementById('loader');
        if (loader) loader.style.display = 'none';
        const body = document.body;
        if (body) body.classList.remove('no-scroll');
        const critical = document.getElementById('loader-critical-css');
        if (critical && critical.parentNode) {
            critical.parentNode.removeChild(critical);
        }
    } catch(_) { /* noop */ }
}

